import {
  Component,
  OnInit,
  HostBinding,
  ChangeDetectorRef,
  ElementRef,
  isDevMode,
} from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { Title } from "@angular/platform-browser";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import { CommonService } from "./common/common.service";
import { restrictPages } from "./common/common.const";
import swal from "sweetalert2";
import { environment } from "../environments/environment";
//declare var Pace;
import { HostListener } from "@angular/core";
import { AuthService } from "./auth/auth.service";
import { HttpClientService } from "./common/http-client.service";
// import * as $ from 'jquery';
import { AccessProvider } from "./access-provider";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  // @HostBinding('class.login-page')
  backdrop: boolean;
  public restrict = false;
  baseTitle: string = "Wallet Admin";
  accessDataFromProvider: any;

  constructor(
    private el: ElementRef,
    private ref: ChangeDetectorRef,
    private router: Router,
    private title: Title,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private commonService: CommonService,
    private http: HttpClientService,
    private accessProvider: AccessProvider
  ) {
    if (isDevMode()) {
      console.log("in dev mode");
    } else {
      console.log("in server mode");
    }
    const currentUrl =
      router.url || window.location.hash || window.location.pathname;
    const isActivationLink =
      currentUrl.includes("/activationlink") ||
      currentUrl.includes("activationlink");

    if (
      localStorage.getItem("loggedAt") &&
      !this.authService.userInfo &&
      !isActivationLink
    ) {
      this.accessDataFromProvider = this.accessProvider.getAccessData();
      this.authService.userInfo = this.accessDataFromProvider;
      if (this.authService.userInfo) {
        this.authService.userInfo = this.commonService.updateAccessInfo(
          this.authService.userInfo
        );
      }
    }

    router.events
      .filter((event) => event instanceof NavigationEnd) //  we can filter out any events that aren’t NavigationEnd
      .map(() => this.activatedRoute) //  we can inject the ActivatedRoute
      .map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }) //  we’ll create a while loop to traverse over the state tree to find the last activated route
      .filter((route) => route.outlet === "primary")
      .mergeMap((route) => route.data) //  Doing this allows us to essentially dive into the children property of the routes config to fetch the corresponding page title(s).
      .subscribe((val) => {
        title.setTitle(
          val["title"] ? val["title"] + " | " + this.baseTitle : this.baseTitle
        );
      });
    // window['Pace'].options = {
    // ajax: {
    // ignoreURLs: ['^http:\/\/devpp.spicelabs.in\/socket.io\/.*$']

    // }
    // }
    // window['Pace'].on("start", () => {
    // this.backdrop = true;
    // })
    // window['Pace'].on("done", () => {
    // this.backdrop = false;
    // ref.detectChanges();
    //  })

    window.addEventListener(
      "offline",
      () => {
        swal({
          title: "Internet Disconnected",
          text: "No connection available",
          showConfirmButton: false,
          allowOutsideClick: false,
        }).then(
          (s) => {},
          (e) => {}
        );
      },
      false
    );

    window.addEventListener(
      "online",
      () => {
        swal.close();
      },
      false
    );
  }

  IDLE_TIMEOUT = 60; //seconds
  _idleSecondsCounter = 0;
  CheckIdleTime() {
    this._idleSecondsCounter++;
    let oPanel = this.el;
    if (oPanel)
      oPanel.nativeElement.html =
        this.IDLE_TIMEOUT - this._idleSecondsCounter + "";
    if (this._idleSecondsCounter >= this.IDLE_TIMEOUT) {
      // alert("Time expired!");
      // document.location.href = "logout.html";
    }
  }
  ngOnInit() {
    document.onclick = () => {
      this._idleSecondsCounter = 0;
    };
    document.onmousemove = () => {
      this._idleSecondsCounter = 0;
    };
    document.onkeypress = () => {
      this._idleSecondsCounter = 0;
    };
    window.setInterval(this.CheckIdleTime, 1000);

    // let token = this.commonService.token;
    // var compRef = this;
    //   $.ajax({
    //     type: "GET",
    //     url: environment.USER_MFS+'userManagement/userDetails',
    //     beforeSend: function (xhr) {
    //       xhr.setRequestHeader('Authorization', token);
    //   },
    //     async: false,
    //     success : function(data) {
    //         console.log(data) ;
    //         let jsonData = JSON.parse(data);
    //         if(jsonData['object']){
    //           compRef.authService.userInfo = jsonData['object'][0];
    //           compRef.authService.userInfo = compRef.commonService.updateAccessInfo(compRef.authService.userInfo);
    //         }
    //     },
    //     error: function () {
    //       console.log();
    //     },
    // });

    // if(!this.authService.userInfo){
    //   console.log('APP starting'+this.authService.userInfo);
    //   this.http.get('userManagement/userDetails',null,7).subscribe((res)=>{
    //     this.authService.userInfo = res['object']?res['object'][0]:null;
    //     if(!this.authService.userInfo){
    //       this.router.navigate(['/auth/login']);
    //     }else{
    //       this.authService.userInfo = this.commonService.updateAccessInfo(this.authService.userInfo);
    //     }
    //   });
    //   // this.authService.userInfo = this.commonService.getStorage('userInfo');
    // }
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/app.component.ts